var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"related-colors"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('Other models available')))]),_vm._v(" "),_c('ul',_vm._l((_vm.items),function(item){return _c('li',[_c('RelatedColorsItem',{attrs:{"item":item}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }